import React from "react";

import "../css/PopupTitleDescriptionItem.css";

export default ({ title, description }) => {
  return (
    <div className="popup-row popup-title-description-item">
      <span className="popup-row-title-description-item">{title}:</span>
      <span>{description}</span>
    </div>
  );
};
